





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
export interface loginFormObject {
  phone: string;
  password: string;
}

@Component({
  name: 'lb-login',
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) private loading!: boolean;
  @Prop() private background!: any;
  @Prop({ type: Boolean, default: true }) private showForget!: boolean;

  private loginForm: loginFormObject = {
    phone: '',
    password: '',
  };
  private rules: object = {
    phone: [
      { required: true, message: '请输入手机号', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  };
  private remember_pass: boolean = false;

  public created() {
    this.getCookies();
  }

  private handleClickLogin() {
    // @ts-ignore
    this.$refs.loginForm.validate((valid: any) => {
      if (valid) {
        const loginInfo = {
          phone: this.loginForm.phone,
          password: this.loginForm.password,
        };
        if (this.remember_pass) {
          this.setCookie(this.loginForm.phone, this.loginForm.password, 7);
        } else {
          this.clearCookie();
        }
        this.$emit('login', loginInfo);
      } else {
        return false;
      }
    });
  }
  private setCookie(phone: string, password: string, exdays: number) {
    const exdate = new Date();
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
    window.document.cookie = 'phone' + '=' + phone + ';path=/;expires=' + exdate.toUTCString();
    window.document.cookie = 'password' + '=' + password + ';path=/;expires=' + exdate.toUTCString();
  }
  private getCookies() {
    if (document.cookie.length > 0) {
      const arr = document.cookie.split('; ');
      for (let i = 0; i < arr.length; i++) {
        const arr2 = arr[i].split('=');
        if (arr2[0] === 'phone') {
          this.loginForm.phone = arr2[1];
          this.remember_pass = true;
        } else if (arr2[0] === 'password') {
          this.loginForm.password = arr2[1];
          this.remember_pass = true;
        } else {
        }
      }
    }
  }
  private clearCookie() {
    this.setCookie('', '', -1);
  }

}
